import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const GET_OFFER_LIST_QUERY = gql`
query offerList( $page: Int, $limit: Int, $sort: String, $sortBy: Int, $searchKey: String, $artistId: ID, $status: String
  , $campaign: [String], $audience: [String], $isExcludeExpiredOffer: Boolean, $isUnreadMessage: Boolean, $gigType: [String], $viewType: [String],) {
    offerList( page: $page, limit: $limit, sort: $sort, sortBy: $sortBy, searchKey: $searchKey,
      isExcludeExpiredOffer: $isExcludeExpiredOffer, artistId: $artistId, status: $status,
       campaign: $campaign, audience: $audience, isUnreadMessage: $isUnreadMessage, gigType: $gigType, viewType: $viewType){
      data {
        _id,
        title,
        offerMaxDate,
        offerMinDate,
        clientName,
        campaignType,
        viewType,
        gigType,
        basePrice,
        description,
        clientLogo,
        isClientLogoHide,
        isNotification,
        coverImage,
        basePriceText,
        startDeadline,
        endDeadline,
        categories {
          value
          label
          }
        targetAudience {
          audienceAge{
            age_13_17,
            age_18_20,
            age_21_24,
            age_25_29,
            age_30_34,
            age_35_44,
            age_45_64,
            age_65_plus
          },
          gender,
          country {
            label
            value
          }
        },
        campaignTimeline {
          startDate,
          endDate,
          shareType {
            instagram,
            facebook,
            twitter,
            spotify,
            youtube,
          }
          campaignTitle,
          description,
          hashTag
        },
        betaPostTimeLine {
          _id,
          timeLine{
            createdAt,
            status,
          },
          segmentId,
          startDate,
          endDate,
          betaPostInfo,
          rejectReason {
            preDefined
            custom
          }
          media {
            _id,
            url,
            thumbnail,
            mediaType,
          },
          shareType {
            instagram,
            facebook,
            twitter,
            spotify,
            youtube,
          },
          sharedPost {
            instagram,
            instagramUrl,
            facebook,
            facebookUrl,
            twitter,
            twitterUrl,
            spotify,
            spotifyUrl,
            youtube,
            youtubeUrl,
          },
          campaignTitle,
          description,
          hashTag,
          status,
        },
        participants {
          rejectReason {
            preDefined,
            custom,
          }
          basePrice
        }
        createContract,
        createdAt,
        isRequested,
        isPublish,
        isContractAccepted,
        notification {
          isDetailRead
        },
        participatingArtist{
          userId{
            name,
            artistImage
          }
        }
      },
      count,
      hasNextData,
     }
  }`;

export const GET_OFFER_DETAIL_QUERY = gql`
query offerDetail($offerId: String!, $artistId: String) {
  offerDetail(offerId: $offerId, artistId: $artistId){
    message
    data {
      _id,
      title,
      clientName,
      campaignType,
      viewType,
      basePrice,
      description,
      offerUrl,
      isNotification,
      clientLogo,
      basePriceText,
      startDeadline,
      endDeadline,
      coverImage,
      gigType,
      isClientLogoHide,
      isBetaPostApproval,
      isArtistParticipation,
      isPinToTop
      participants {
        rejectReason {
          preDefined,
          custom,
        }
        basePrice,
        vanityUrl,
      },
      categories {
        value
        label
      }
      targetAudience{
        audienceAge{
          age_13_17,
          age_18_20,
          age_21_24,
          age_25_29,
          age_30_34,
          age_35_44,
          age_45_64,
          age_65_plus
        },
        gender,
        country{
          label
          value
        }
      },
      campaignTimeline{
        startDate,
        endDate,
        _id,
        shareType{
          instagram,
          facebook,
          twitter,
          spotify,
          youtube,
        }
        campaignTitle,
        description,
        hashTag,
        _id
      },
      createContract,
      createdAt,
      isRequested,
      isAdminRequested,
      isContractAccepted,
      isPublish,
      offerMinDate,
      offerMaxDate,
      status,
      betaPostTimeLine {
        _id,
        timeLine{
          createdAt,
          status,
        },
        segmentId,
        startDate,
        endDate,
        betaPostInfo,
        rejectReason {
          preDefined
          custom
        }
        media {
          _id,
          url,
          thumbnail,
          mediaType,
        },
        shareType {
          instagram,
          facebook,
          twitter,
          spotify,
          youtube,
        },
        sharedPost {
          instagram,
          instagramUrl,
          facebook,
          facebookUrl,
          twitter,
          twitterUrl,
          spotify,
          spotifyUrl,
          youtube,
          youtubeUrl,
        },
        campaignTitle,
        description,
        hashTag,
        status,
      },
      segmentParticipants {
        campaignTitle,
        betaPostId,
        startDate,
        endDate,
        description,
        hashTag,
        segmentId,
        shareType {
          instagram,
          facebook,
          spotify,
          twitter,
          youtube,
        },
        sharedPost {
          instagramUrl,
          facebookUrl,
          twitterUrl,
          spotifyUrl,
          youtubeUrl,
        },
        participants {
          media {
            url
            _id
            thumbnail
            mediaType
          }
          user {
            _id
            name
            artistImage
          }
          timeLine {
            status
            createdAt
          }
          rejectReason {
            preDefined
            custom
          }
          sharedPost {
            instagramUrl,
            facebookUrl,
            twitterUrl,
            spotifyUrl,
            youtubeUrl,
          }
          status,
          betaPostInfo,
        }
      }
    },
    request {
      createdAt,
      userId {
        name,
        artistImage,
        _id,
        email
      },
      email,
      managerId {
        email
      }
    },
    invitedArtist{
      email,
      isRequested,
      isAlreadyRequested,
      isInviteeArtist,
    },
    recomended {
      timeLine{
        status
        createdAt
      },
      basePrice,
      userId {
        name,
        email
      },
      email,
      managerId {
        email
      }
      artistImage,
      name,
      isRequested,
      isRecomended,
      _id,
      country {
        label,
        value
      },
      city {
        label,
        value
      },
      state {
        label,
        value
      },
      isAlreadyRequested,
    }
  }
}`;

export const GET_DEMOGRAPHIC_DATA_QUERY = gql`
query getDemographic($artistId: ID){
  getDemographic(artistId: $artistId){
    message
    hasData,
    data {
      updatedAt,
      followers{
        instagram,
        facebook,
        spotify,
        youtube,
        twitter,
        website
      }
      audienceAge{
        age_13_17,
        age_18_20,
        age_21_24,
        age_25_29,
        age_30_34,
        age_35_44,
        age_45_64,
        age_65_plus
      }
      authenticFollowers,
      topCountry{
        country1 {
          label,
          value
        },
        country2 {
          label,
          value
        },
        country3 {
          label,
          value
        },
        countryFollowers1,
        countryFollowers2,
        countryFollowers3
      },
      topState{
        stateCountry1 {
          label,
          value
        },
        state1 {
          label,
          value
        },
        stateCountry2 {
          label,
          value
        },
        state2 {
          label,
          value
        },
        stateCountry3 {
          label,
          value
        },
        state3 {
          label,
          value
        },
        stateCountry4 {
          label,
          value
        },
        state4 {
          label,
          value
        },
        stateCountry5 {
          label,
          value
        },
        state5 {
          label,
          value
        },
        stateFollowers1,
        stateFollowers2,
        stateFollowers3,
        stateFollowers4,
        stateFollowers5
      },
      audienceGender{
        male,
        female,
      },
      audienceEthnicity{
        american,
        asian,
        white,
        hispanic,
      },
      engagementRate{
        facebookRate,
        instagramRate,
        twitterRate,
      },
    }
  }
}`;

export const GET_ASSOCIATED_DATA_QUERY = gql`
query associatedOffer($artistId: ID, $managerId: ID){
  associatedOffer(artistId: $artistId, managerId: $managerId){
    message
    data {
      offerStatus
      basePrice
      offerData {
        _id
        title
        clientLogo
        offerMinDate
        offerMaxDate
        viewType
      }
      userId{
        _id,
        name,
        artistImage
      }
    }
    associatedCount
  }
}`;

export const GET_OFFER_PARTICIPATING_ARTIST = gql`
query participatingOfferArtist($offerId: ID!, $page: Int!, $limit: Int!){
  participatingOfferArtist(offerId: $offerId, page: $page, limit: $limit){
    message
    data {
      email,
      managerId {
        email
      }
      userId {
        name,
        artistImage,
        _id,
        email,
        managerId {
          email
        }
      },
      basePrice,
      isNotification,
    },
    count,
    hasNextData,
  }
}`;

export const GET_PENDING_CONTRACT_ARTIST = gql`
query artistPendingContract($offerId: ID!, $page: Int!, $limit: Int!){
  artistPendingContract(offerId: $offerId, page: $page, limit: $limit){
    message,
    data {
      isNotification,
      email,
      managerId {
        email
      }
      userId {
        name,
        artistImage,
        _id,
        email,
        managerId {
          email
        }
      },
      basePrice,
      offerId{
        _id,
        title,
        clientName,
        clientLogo,
        offerMaxDate,
        offerMinDate,
      }
    },
    count,
    hasNextData,
  }
}`;

export const GET_REJECTED_ARTIST_LIST = gql`
query rejectedArtist($offerId: ID!, $page: Int!, $limit: Int!){
  rejectedArtist(offerId: $offerId, page: $page, limit: $limit){
    message
    data {
      email,
      managerId {
        email
      }
      userId {
        name,
        artistImage,
        _id,
        email,
        managerId {
          email
        }
      },
      rejectReason {
            preDefined
            custom
          }
      basePrice,
    },
    count,
    hasNextData,
  }
}`;

export const GET_SHARED_BETA_POST_DETAILS = gql`
query shareBetaPost($betaPostId: ID!, $userId: ID!){
  shareBetaPost(betaPostId: $betaPostId, userId: $userId){
    message
    data {
      media {
        url
        _id
        thumbnail
        mediaType
      },
      userId {
        name,
        artistImage,
      }
      betaPostInfo,
      offerId {
        title,
        clientName,
        viewType,
        campaignType,
        description
        clientLogo,
        offerMinDate,
        offerMaxDate
      }
    }
  }
}`;

export const GET_OFFER_REQUEST_LIST = gql`
query requestedArtistList($offerId: ID!, $page: Int, $limit: Int){
  requestedArtistList(offerId: $offerId, page: $page, limit: $limit){
    message
    data {
      createdAt,
      userId {
        name,
        artistImage,
        _id,
        email
      },
      email,
      managerId {
        email
      }
    },
    count,
    hasNextData,
  }
}`;

export const GET_OFFER_RECOMMENDED_LIST = gql`
query recommendedUsernew($offerId: ID!, $page: Int, $limit: Int){
  recommendedUsernew(offerId: $offerId, page: $page, limit: $limit){
    message
    data {
      basePrice,
      userId {
        name,
        email
      },
      email,
      managerId {
        email
      }
      artistImage,
      name,
      isRequested,
      isRecomended,
      isInviteeArtist,
      _id,
      country {
        label,
        value
      },
      city {
        label,
        value
      },
      state {
        label,
        value
      },
      isAlreadyRequested,
    },
    count,
    hasNextData,
  }
}`;

export const GET_OFFER_INVITED_LIST = gql`
query invitedArtistList($offerId: ID!, $page: Int, $limit: Int){
  invitedArtistList(offerId: $offerId, page: $page, limit: $limit){
    message
    data {
      email
      isRequested
      isInviteeArtist
      isAlreadyRequested
    },
    count,
    hasNextData,
  }
}`;
